import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "22.05.2020r",
    category: "strona WWW, marketing internetowy",
    title: "Jaka powinna być nowoczesna strona internetowa?",
    description:
      "Rozwój technologii sprawia, że strony WWW, które powstały 2 czy 3 lata temu dzisiaj mogą być już nieaktualne! Zbyt wolna, nieestetyczna i niedostosowana do urządzeń mobilnych witryna będzie odstraszać potencjalnych klientów i kontrahentów, co może generować poważne straty dla Twojego biznesu. Dowiedz się, po czym poznać, że Twoja strona internetowa jest nieaktualna, co jaki czas warto ją zmienić i nie pozwól, by Twój biznes odnotował stratę z tak prostego powodu!",
    seo:
      "Rozwój technologii sprawia, że strony WWW, które powstały 2 czy 3 lata temu dzisiaj mogą być już nieaktualne",
    slug: "/blog/jaka_powinna_byc_nowoczesna_strona_internetowa",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "Zadbaj o responsywność",
        text: (
          <>
            Mówi się, że w informatyce 10 lat to jak stulecie w każdej innej
            dziedzinie nauki. W 2010 roku, który tak wielu z nas wydaje się
            zupełnie nieodległym, powstało pojęcie <b>Responsive Web Design,</b>{" "}
            które określało automatyczne dostosowanie układu strony internetowej
            do rozdzielczości urządzenia. Stanowiło to odpowiedź na coraz
            bardziej zróżnicowane potrzeby użytkowników, na początku przecież w
            ogóle nieskomplikowane. Istniała jedna rozdzielczość ekranu, a
            webdeveloperów mocno ograniczała szybkość łącza i zaawansowanie
            technologii komputerowej. (Kto z nas nie pamięta kart pamięci do
            telefonów z pierwszej dekady XXI wieku, które miały zawrotną
            pojemność 2MB? Dziś najpopularniejsza karta tego rozmiaru mieści
            128GB, a większość ludzi nie tylko jest podłączona do sieci, ale też
            używa jej <b>na różnych urządzeniach</b> przy dużej przepustowości
            łącza.)Z roku na rok coraz więcej użytkowników używa internetu na
            urządzeniach mobilnych. Stało się to swego rodzaju rytuałem:
            przeglądamy strony w drodze do i z pracy, w poczekalni u lekarza, w
            kolejce do kasy w sklepie czy w łazience. Jeśli potencjalni klienci
            po wejściu na Twoją stronę natrafią na mur w postaci{" "}
            <b>braku wersji mobilnej</b> - zwyczajnie zrezygnują z dalszego
            przeglądania, bo zaznajomienie się z Twoją ofertą będzie dla nich
            zbyt czasochłonne.
          </>
        ),
      },
      second: {
        title: "Nie każ czekać za długo",
        text: (
          <>
            Rozwój technologii wpływa również na oczekiwania i nastroje samych
            użytkowników. Kiedyś półgodzinne czekanie na stronę internetową było
            normą - cieszyliśmy się, że cokolwiek możemy zobaczyć. Dzisiaj 30
            sekund jest irytująco długie i niepotrzebne. Dlatego,{" "}
            <b>jeśli Twoja strona WWW ładuje się zbyt długo,</b> czas ją
            zmienić!To nie tylko pomoże zatrzymać potencjalnych klientów, ale
            również pomóc przy <b>pozycjonowaniu</b> witryny w wyszukiwarce
            Google.
          </>
        ),
      },
      third: {
        title: "Postaw na intuicyjny interfejs",
        text: (
          <>
            Z punktu widzenia użytkownika bardzo ważny jest również czytelny i
            intuicyjny interfejs. Współczesny internauta oczekuje, że wszystkie
            <b>potrzebne informacje znajdzie w prosty sposób,</b> bez
            niepotrzebnego przekopywania się przez nieistotne dla niego
            informacje. Dlatego zwróć uwagę, czy na swojej stronie WWW w jasny
            sposób pokazujesz, czym zajmuje się Twój biznes oraz zadbaj o{" "}
            <b>łatwy dostęp do danych kontaktowych.</b>
          </>
        ),
      },
      fourth: {
        title: "Zmień stronę internetową w narzędzie wsparcia biznesu",
        text: (
          <>
            Również ważna jest wymowa Twojej strony internetowej. Zwykło się
            mówić o witrynie w kontekście wizytówki firmy, nie zapominaj jednak,
            że <b>jej możliwości są znacznie szersze - i wykorzystaj je.</b>{" "}
            Współczesne strony internetowe to <b>potężne narzędzie,</b>
            które pozwoli Ci nie tylko poinformować odbiorców o profilu Twojej
            działalności czy nawet <b>zachęcić</b> ich do tego, ale również może{" "}
            <b>
              przeprowadzić klienta przez cały proces sprzedażowy i dowiedzieć
              się o nim jak najwięcej
            </b>{" "}
            - tak, by móc dotrzeć do większego grona osób potencjalnie
            zainteresowanych profilem Twojej działalności.Ważna jest warstwa nie
            tylko zewnętrzna - odpowiednia oprawa tekstowa
            <b>
              (stosowanie języka korzyści czy dopasowanie tekstów pod kątem SEO)
            </b>{" "}
            i graficzna, ale również wszystkie narzędziaukryte pod spodem,
            których nie widać dla klienta - a które są ważne dla Ciebie. Dzięki
            technologii jesteś w stanie{" "}
            <b>poznać zachowania swoich odbiorców,</b> a nawet zrozumieć,
            dlaczego - na przykład - na pewnym etapie zrezygnowali z Twoich
            usług. Te narzędzia pozwolą Ci dużo łatwiej i szybciej rozwinąć swój
            biznes.
          </>
        ),
      },
      fifth: {
        title: "Wykreuj nowoczesny wizerunek",
        text: (
          <>
            Ostatnim aspektem, bardzo ważnym, ale często pomijanym przez
            przedsiębiorców, jest wygląd strony internetowej - jest to poważny
            błąd! <b>Design</b> to nie tylko <b>estetyka</b> (która sama w sobie
            również jest istotna) - to również{" "}
            <b>funkcjonalność, użyteczność i praktyczność.</b> Odpowiednio
            zaprojektowana strona internetowa powinna być atrakcyjna dla
            użytkownika również wizualnie.Trendy w projektowaniu stron WWW
            zmieniają się bardzo szybko, ale każdy internauta jest w stanie
            zauważyć, że odwiedzana przez niego witryna jest niemłoda. To rodzi
            pytania o aktualność danych zawartych na stronie, podejście do
            klienta, a nawet podejrzenie o brak innowacyjności i stagnację, brak
            rozwoju firmy. Dlatego właśnie <b>2-3 lata są optymalnym czasem,</b>
            po którym powinniśmy pomyśleć o zmianie lub odświeżeniu swojej
            strony internetowej.
          </>
        ),
      },
      sixth: {
        text:
          "Czas pędzi do przodu. Twój biznes również. Nie pozwól, by konkurencja zostawiła Cię w tyle i wykreuj wizerunek firmy jako nowoczesnej i dbającej o szczegóły. Strona internetowa to nierzadko pierwszy kontakt między Twoją marką a potencjalnym klientem czy kontrahentem. Zadbaj o to, by to pierwsze wrażenie było jak najlepsze.",
      },
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_4.childImageSharp.fluid}
        />
      ),
    },
  };
};
